import styled from "styled-components";
import CellStyled from "./Cell.styled";
import texture from './assets/texture.jpg'

type Props = {
    $height?: number,
    $skewStrength?: number,
    $hueRotate?: number,
    $contrast?: number,
    $brightness?: number,
    $saturate?: number,
    $grayscale?: number,
    $image?:string,
    $dense?: boolean,
}
export default styled.div<Props>`
    display: flex;
    flex-direction: row;

    &:nth-child(3n+1) ${CellStyled} {
        height:  ${({ $height }) => $height && `${($height || 1) * 11.5}rem`};
        filter: 
            hue-rotate(${props => (props.$hueRotate || 0)}deg)
            contrast(${props => (props.$contrast || 110)}%)
            brightness(${props => (props.$brightness || 110)}%)
            saturate(${props => (props.$saturate || 120)}%)
            grayscale(${props => (props.$grayscale || 0)})
            ;
        transform:
            skewX(${props => (props.$skewStrength || 1)}deg)
            translateX(${props => (props.$skewStrength || 1) * 1.5}px)
        ;
        
    }

    &:nth-child(3n+1) ${CellStyled}:nth-child(2n+1) {
           ${({ $dense = false }) => $dense ? `
                padding: 1rem;
            ` : `
                padding: 2.5rem 2.5rem 1rem 2.5rem;
            `}
        
    }
    &:nth-child(3n+1) ${CellStyled}:nth-child(2n) {
        padding: 2.5rem 2.5rem 1rem 1rem;
    }

    &:nth-child(3n+2) ${CellStyled} {
        height: ${props => (props.$height || 1) * 13.5}rem;
        filter:  
            hue-rotate(${props => (props.$hueRotate || 0)}deg)
            contrast(${props => (props.$contrast || 110)}%)
            brightness(${props => (props.$brightness || 95)}%)
            saturate(${props => (props.$saturate || 100)}%)
            grayscale(${props => (props.$grayscale || 0)})
            ;

        transform:
            skewX(${props => (props.$skewStrength || 1) * -1}deg)
            translateX(${props => (props.$skewStrength || 1) * 1.3}px)
        ;
    }

    &:nth-child(3n+2) ${CellStyled}:nth-child(2n+1) {
        padding: 1rem 1rem 1rem 2.5rem;
    }
    &:nth-child(3n+2) ${CellStyled}:nth-child(2n) {
        padding: 1rem 2.5rem 1rem 1rem;
    }


    &:nth-child(3n) ${CellStyled} {
        height: ${props => (props.$height || 1) * 13}rem;
        filter:
            hue-rotate(${props => (props.$hueRotate || 0)}deg)
            contrast(${props => (props.$contrast || 120)}%)
            brightness(${props => (props.$brightness || 102)}%)
            saturate(${props => (props.$saturate || 120)}%)
            grayscale(${props => (props.$grayscale || 0)})
            ;
        transform:
            skewX(${props => (props.$skewStrength || 1)}deg)
            translateX(${props => (props.$skewStrength || 1) * 0.1}px)
        ;

    }

    &:nth-child(3n) ${CellStyled}:nth-child(2n+1) {
        padding: 1rem 1rem 2rem 2.5rem;
    }

    &:nth-child(3n) ${CellStyled}:nth-child(2n) {
        padding: 1rem 2.5rem 2rem 1rem;
    }

    &:nth-child(2n+1) ${CellStyled} {
        ${({$image}) => $image ? `
            background-image: linear-gradient(to bottom, rgba(76, 53, 73, 0.02) 0%, rgba(76, 53, 73, 0.00) 72%, rgba(76, 53, 73, 0.15) 95%, rgba(76, 53, 73, 0.24) 100%), url(${$image}), url(${texture});
            background-blend-mode: multiply;
            background-size: 100% 100%, 90% 270%, 100% 100%;
            background-position: 0% 0%, 50% -9%, 0% 0%;
            background-repeat: no-repeat;
        ` : `
            background-image: linear-gradient(to bottom, rgba(76, 53, 73, 0.02) 0%, rgba(76, 53, 73, 0.00) 72%, rgba(76, 53, 73, 0.15) 95%, rgba(76, 53, 73, 0.24) 100%), url(${texture});
            background-size: 100% 100%;
        `}
    }


    &:nth-child(2n) ${CellStyled} {
        ${({$image}) => $image ? `
            background-image: linear-gradient(to top, rgba(76, 53, 73, 0.08) 0%, rgba(76, 53, 73, 0.00) 40%, rgba(76, 53, 73, 0.14) 100%), url(${$image}), url(${texture});
            background-blend-mode: multiply;
            background-size: 100% 300%;
            background-position: 0% 50%;
            background-size: 100% 100%, 90% 270%, 100% 100%;
            background-position: 0% 0%, 50% 50%, 0% 0%;
            background-repeat: no-repeat;
        ` : `
        background-image: linear-gradient(to top, rgba(76, 53, 73, 0.08) 0%, rgba(76, 53, 73, 0.00) 40%, rgba(76, 53, 73, 0.14) 100%), url(${texture});
        background-size: 100% 100%;
        `}
    }

    &:last-child ${CellStyled} {
            ${({$image}) => $image ? `
            background-image: url(${$image}), url(${texture});
            background-blend-mode: multiply;
            background-size: 90% 270%, 100% 100%;
            background-position: 50%  108.5%, 0% 0%;
            background-repeat: no-repeat;
        ` : `
            background-image: url(${texture});
            background-size: 100% 100%;
        `}
    }
`